// export const pxInMM = 37.7952755905512 / 10; // 1MM = 37.7952px, 1mm = 3.77952px
// export const mmInPx = 1 / mmInPx; // 1px = 0.0264583333MM, 1px = 0.264583333mm
export const MM_TO_INCHES = 25.4;

export const calculateDimInPx = (dimInMM: number, dpi: number) => {
  return (dimInMM * dpi) / MM_TO_INCHES;
}
export const calcPxInMM = (dpi: number) => {
  return dpi / MM_TO_INCHES;
}
export const convertPointsToPixels = (points: number, dpi: number) => {
  return (points * dpi) / 72;
};

export const calcTextWidth = (text: string, fontSize: number, fontFamily: string, dpi: number, fontWeight: string = 'normal') => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) return text.length; // Canvas not supported

  context.font = `${fontWeight} ${convertPointsToPixels(fontSize || 10, dpi)}px ${fontFamily}`;
  const width = context.measureText(text).width;
  const widthInMm = (width * 25.4) / dpi; // Convert width from pixels to millimeters

  return widthInMm;
};

export const round = (number: number | undefined) => {
  if(!number) return number;
  return Math.round((number + Number.EPSILON) * 100) / 100;
}

export const defaultPath = ""; //"C:/Users/mariiakin/Desktop/";

export const orientation = {
  portrait: "Portrait",
  landscape: "Landscape",
};

export const zoomOptions = Array.from({length: 12}, (_, i) => {
  const value = 0.25 * (i + 1);
  return {
    key: String(value * 100),
    text: `${value * 100}%`,
    value,
  };
});

export const removeDateFromName = (name: string) => {
  //match date pattern YYYY-MM-DD_HH-MM-SS
  const datePattern = /_\d{4}-\d{2}-\d{2}_\d{2}-\d{2}-\d{2}/;
  return name.replace(datePattern, "");
};

export const getCurrentTimestamp = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}_${hours}-${minutes}`;
};

export const rotationAngles = [
  {
    key: "0",
    text: "0°",
    value: 0,
  },
  {
    key: "90",
    text: "90°",
    value: 90,
  },
  {
    key: "180",
    text: "180°",
    value: 180,
  },
  {
    key: "270",
    text: "270°",
    value: 270,
  },
];

export const align = {
  left: "left",
  center: "center",
  right: "right",
};

export const defaultMinValues = ["01.01.0001", "0001.01.01", "0001-01-01", 
  "01-01-0001", "01/01/0001", "0001/01/01", "0001.01.01 00:00:00", "01.01.0001 00:00:00", 
  "0001-01-01 00:00:00", "01-01-0001 00:00:00", "01/01/0001 00:00:00", "0001/01/01 00:00:00",
  "0", "1900.01.01", "1900-01-01", "1900-01-01 00:00:00", "1900.01.01 00:00:00", "1900/01/01", "1900/01/01 00:00:00",
  "01.01.1900", "01-01-1900", "01/01/1900", "01.01.1900 00:00:00", "01-01-1900 00:00:00", "01/01/1900 00:00:00",
];